export { default } from './AddWriterDetails';
